export function normalizeOptions(items, searchFields = []) {
    if (!Array.isArray(items)) return [];

    const getValueByPath = (obj, path) => {
        return path
            .split('.')
            .reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : ''), obj);
    };
    return items.map((item) => {
        const parts = searchFields
            .map((field) => {
                const value = getValueByPath(item, field);
                return value !== null && value !== undefined && value !== ''
                    ? String(value).trim()
                    : '';
            })
            .filter((v) => v);
        const display = parts.join(' ');

        return {
            id: item.id ?? null,
            value: display.trim()
        };
    });
}

